import { Button, Text, Flex, Box, Heading, Icon } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import history from '../../../../../history'
import { selectCustomerFirstName } from '../../../../../store/selectors/customerProfile'
import { List, Page, SectionWrapper } from '../../../..'
import { OverlayQuestionsFooter } from '../../../Routing'
import { CUSTOMER_MESSAGES } from '../../../../../constants/customerMessages'
import { selectHomeValue } from '../../../../../store/selectors/home/metadata'
import { HomeValueEstimateAnimation } from '../HomeValueEstimateAnimation'
import { HomeValueEstimate } from '../Value'
import { HOMEOWNER_DIGEST_AVM_PANEL } from '../../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  headingOne: {
    id: 'HomeValueEstimatePanel.headingOne',
    defaultMessage: 'How is your home value estimate calculated?'
  },
  headingOneBody: {
    id: 'HomeValueEstimatePanel.headingOne.body',
    defaultMessage:
      'Homebot uses an automated valuation model (AVM) to provide an estimated home value. The main market data that helps calculate this value are your home details and similar home sale trends in your area.'
  },
  headingTwo: {
    id: 'HomeValueEstimatePanel.headingTwo',
    defaultMessage: 'Does your estimate look off?'
  },
  headingTwoBody: {
    id: 'HomeValueEstimatePanel.headingTwo.body',
    defaultMessage:
      'The AVM you see is a data-based estimate, but you know your home best! AVMs do not account for things like recent remodeling and home improvements, so you can quickly tune your value to personalize your home report.'
  },
  button: {
    id: 'HomeValueEstimatePanel.button.title',
    defaultMessage: 'Tune value'
  },
  customerContact: {
    id: 'HomeValueEstimatePanel.customerContact.body',
    defaultMessage:
      'AVM data should never replace the guidance of a real estate professional. You can always reach out to {customerFirstName} for help updating your home value.'
  },
  limitationsHeading: {
    id: 'HomeValueEstimatePanel.limitations.heading',
    defaultMessage: 'Home value limitations'
  },
  limitationsDescription: {
    id: 'HomeValueEstimatePanel.limitations.description',
    defaultMessage:
      'Since your AVM is based on computer models built with public market information and records, this estimate has limitations that can affect its accuracy, such as:'
  },
  lackOfData: {
    id: 'HomeValueEstimatePanel.limitations.lackOfData',
    defaultMessage: 'Lack of data in non-disclosure states'
  },
  recentImprovements: {
    id: 'HomeValueEstimatePanel.limitations.recentImprovements',
    defaultMessage: 'Value-adding new home improvements'
  },
  majorChanges: {
    id: 'HomeValueEstimatePanel.limitations.majorChanges',
    defaultMessage: 'Major market changes near you'
  }
})

export const HomeValueEstimatePanel = () => {
  const intl = useIntl()
  const marginSize = '6'
  const customerFirstName = useSelector(selectCustomerFirstName)
  const homeValue = useSelector(selectHomeValue)

  const handleOnClick = () => {
    history.push(OVERLAY_HELPERS.tuneYourValue.buildPath())
  }

  return (
    <Page>
      <Page.Body>
        <Flex direction='column' w='100%' alignItems='flex-start' p='4'>
          <HomeValueEstimate avm={homeValue} />
          <HomeValueEstimateAnimation />
          <Heading marginBottom='1' textAlign='left' size='sm' fontWeight='semibold'>
            {intl.formatMessage(MSG.headingOne)}
          </Heading>

          <Text size='sm' align='left'>
            {' '}
            {intl.formatMessage(MSG.headingOneBody)}
          </Text>
          <Heading marginTop='8' marginBottom='1' textAlign='left' size='sm' fontWeight='semibold'>
            {intl.formatMessage(MSG.headingTwo)}
          </Heading>
          <Text size='sm' align='left'>
            {' '}
            {intl.formatMessage(MSG.headingTwoBody)}
          </Text>
          <Button
            onClick={handleOnClick}
            marginTop={marginSize}
            colorScheme='secondary'
            leftIcon={<Icon name='wrench' />}
            tracking={{
              guid: 'kpZDuPZu9sVEdP1JWCu4d5',
              ui_context: HOMEOWNER_DIGEST_AVM_PANEL,
              descriptor: MSG.button.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.button)}
          </Button>
          <Text marginTop={marginSize} size='sm' align='left'>
            {intl.formatMessage(MSG.customerContact, { customerFirstName })}
          </Text>
          <Box marginTop='8'>
            <SectionWrapper data-qa='home-value-limitations'>
              <Heading marginBottom='1' textAlign='left' size='sm' fontWeight='semibold'>
                {intl.formatMessage(MSG.limitationsHeading)}
              </Heading>
              <Text textAlign='left' size='sm' marginBottom='2'>
                {intl.formatMessage(MSG.limitationsDescription)}
              </Text>
              <List.Bulleted>
                {[MSG.lackOfData, MSG.recentImprovements, MSG.majorChanges].map(msg => (
                  <Text key={msg.defaultMessage} size='sm' textAlign='left'>
                    {intl.formatMessage(msg)}
                  </Text>
                ))}
              </List.Bulleted>
            </SectionWrapper>
          </Box>
        </Flex>
      </Page.Body>
      <Page.Footer>
        <OverlayQuestionsFooter
          topic={CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.topic}
          topicKey={CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.topicKey}
          questions={[
            CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.message,
            CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.secondaryMessage
          ]}
          placeholder
          disableCospo
        />
      </Page.Footer>
    </Page>
  )
}
